import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import Works from '@/components/Redesign/Works';
import { useRefitSingleLanding } from '@/modules/RefitSingleLanding/hooks';
import {
  ContentContainer,
  Title,
} from '@/modules/RefitSingleLanding/common.styles';

function WorkTypes() {
  const {
    templateFields: { workTitle, workImage, workPoints },
  } = useRefitSingleLanding();

  if (!workTitle || !workPoints || workPoints.length === 0) {
    return null;
  }

  const list = workPoints.map(({ point }) => ({
    point: point ?? '',
  }));

  return (
    <Component>
      <ContentContainer>
        <Title>{workTitle}</Title>
        <Works image={workImage} worksList={list} />
      </ContentContainer>
    </Component>
  );
}

export default WorkTypes;

const Component = styled.section`
  margin-top: 60px;

  ${media.tablet(css`
    margin-top: 40px;
  `)}
`;
